"use strict";

import AddressAction from "./profile/AddressActionClass";
import CartActions from "./product/CartActionsClass";

if($('.checkout_order').length) {
    let addressAction = new AddressAction();

    window.ALL_DATA = {};
    window.ONLY_BY = false;

    $('form').on('submit', function(e) {
        e.preventDefault();
    });

    //GA Check if user auth
    try {
        let stepData = {
            step: 1,
            option: 'already have an account'
        };
        window.GA.pushCheckoutSteps(stepData);
    } catch (e) {
        console.error(e);
    }


    /**
     * Step 1
     */

    // Pre - Register, send sms
    $('body').on('click', '.sms-checkout__again-reg', function() {

        let form = $(this).closest('form');
        let action = $(this).data('href');

        if( form.find('input[type="tel"]').hasClass('completed') && form.find('input[name="name"]').val().length
            && form.find('input[name="surname"]').val().length && form.find('input[name="politic"]:checked').length){

            let formData = new FormData($(form)[0]);
            formData.append('first_name', $checkoutRegisterForm.find('input[name="name"]').val());
            formData.append('sure_name', $checkoutRegisterForm.find('input[name="surname"]').val());

            let req = $.ajax({
                method: 'post',
                url: action,
                processData: false,
                contentType: false,
                data: formData
            });

            req.done(function (resp) {

                if (resp.success) {
                    timerCheckoutMain('#checkout_register');
                } else {
                    bindErrors(form,resp);
                }

            });

        } else {

            form.find('input[name="name"]').valid();
            form.find('input[name="surname"]').valid();
            form.find('input[type="tel"]').valid();
            form.find('input[name="politic"]').valid();

        }

    });


    // Register
    let $checkoutRegisterForm = $('#checkout_register');
    let $checkoutRegisterFormInit = $checkoutRegisterForm.validate({

        ignore: '.ignore',
        highlight: function(element) {
            $(element).addClass("valid-error").removeClass("success");
        },
        unhighlight: function(element) {
            $(element).removeClass("valid-error").addClass("success");
        },
        errorPlacement: function(error, element) {
            if (element.attr("name") == "politic" ) {
                error.appendTo(element.parent());
            } else {
                error.insertAfter(element);
            }
        },
        rules: {
            name: "required",
            surname: "required",
            password: "required",
            politic: "required",
            password_confirmation: {
                equalTo: ".password_first"
            },
            sms_code: {
                minlength: 4
            }
        },
        submitHandler: function(form){

            let action = $(form).attr('action'),
                formData = new FormData($(form)[0]);

            let isRegister = $(form).find('input[name="is_register"]:checked');

            formData.append('first_name', $checkoutRegisterForm.find('input[name="name"]').val());
            formData.append('sure_name', $checkoutRegisterForm.find('input[name="surname"]').val());

            // always on. #47393
            if(isRegister.length || true) {

                $(form).find('button[type="submit"]').prop('disabled', true);
                $.ajax({
                    type: "POST",
                    url: action,
                    processData: false,
                    contentType: false,
                    data: formData
                })
                .then(function (resp) {
                    if(resp.success) {

                        if(resp.data) {
                            insertIserData( resp.data.name, resp.data.sure_name, resp.data.phone_face, resp.data.email );
                            fillStepTwoData();
                        }
                        afterAuth();
                        $checkoutRegisterForm.closest('.checkout_wrap_row').find('.ch_l').addClass('no_edit');
                        $checkoutLoginForm.closest('.checkout_wrap_row').find('.btn-simple').hide();

                        let from = $(form).closest('.checkout_wrap_row').attr('id'),
                            to = $(form).closest('.checkout_wrap_row').attr('data-to');

                        secondSlide(from, to);

                    } else {

                        bindErrors(form,resp);

                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 422) {
                        let errorObj = {};
                        if(jqXHR.responseJSON.errors) {
                            const objErrors = jqXHR.responseJSON.errors;
                            for (let property in objErrors) {
                                errorObj[property] = objErrors[property].join(',');
                            }
                        }
                        $checkoutRegisterFormInit.showErrors(errorObj);
                    }
                })
                .always(function () {
                    $(form).find('button[type="submit"]').prop('disabled', false);
                });

            } else {

                // Only order without registration, fast check code and go step 2
                let req = $.ajax({
                    method: 'post',
                    url: $(form).data('justsms'),
                    data: $(form).serialize()
                });

                req.done(function (resp) {

                    if (resp.success) {

                        let name = $(form).find('input[name="name"]').val(),
                            phone = $(form).find('input[name="phone"]').val(),
                            email = $(form).find('input[name="email"]').val();

                        insertIserData( name, name, phone, email ); // fix name

                        //$checkoutRegisterForm.closest('.checkout_wrap_row').find('.ch_l').addClass('no_edit');

                        let from = $(form).closest('.checkout_wrap_row').attr('id'),
                            to = $(form).closest('.checkout_wrap_row').attr('data-to');

                        secondSlide(from, to);

                        window.ONLY_BY = true;

                    } else {
                        bindErrors(form,resp);
                    }

                });

            }
        }
    });


    //checkbox
    $('label[for="checkout_register_label"]').click(function(){
        if ($('#checkout_register_label').is(':checked')){
            $('#checkout_register_label ~ .form-group input').addClass('ignore');
            $('#reg_email').prop('required', false);
            $('label[for="reg_email"] span').html('');
        } else {
            $('#checkout_register_label ~ .form-group input').removeClass('ignore');
            $('#reg_email').prop('required', true);
            $('label[for="reg_email"] span').html('*');
        }
    });


    // Pre - Login, send sms
    $('body').on('click', '.sms-checkout__again-old', function(e) {

        e.preventDefault();

        let form = $(this).closest('form');
        let action_as_phone = $(this).data('phone');
        let action_as_pin = $(this).data('pin');

        $('#login_card').next('label').hide();
        $('#login_phone_checkout').next('label').hide();

        // select both
        if( form.find('input[type="tel"]').hasClass('completed') && $('#login_card').val().length){

            let msgs = {
                "errors":{
                    "phone":"Оберіть лише один з запропоновоних варіантів",
                    "pin":"Оберіть лише один з запропоновоних варіантів"
                }};
            bindErrors(form,msgs);
            return false;
        }

        // auth as phone
        if( form.find('input[type="tel"]').hasClass('completed')){

            let req = $.ajax({
                method: 'post',
                url: action_as_phone,
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    timerCheckoutMain('#checkout_login');
                } else {
                    bindErrors(form,resp);
                }

            });

            return true;

        }

        // auth as pin
        if( $('#login_card').val().length){

            let req = $.ajax({
                method: 'post',
                url: action_as_pin,
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    timerCheckoutMain('#checkout_login');
                } else {
                    bindErrors(form,resp);
                }

            });

            return true;

        }

        $(this).closest('form').find('input[type="tel"]').valid();
        return true;

    });


    // Login
    var $checkoutLoginForm = $('#checkout_login');
    let $checkoutLoginFormInit = $checkoutLoginForm.validate({
        highlight: function(element) {
            $(element).addClass("valid-error").removeClass("success");
        },
        unhighlight: function(element) {
            $(element).removeClass("valid-error").addClass("success");
        },
        //Send form
        submitHandler: function(form){

            let action = $(form).attr('action');
            let formData = new FormData($(form)[0]);
            $(form).find('button[type="submit"]').prop('disabled', true);

            $.ajax({
                type: "POST",
                url: action,
                processData: false,
                contentType: false,
                data: formData
            })
            .then(function (resp) {
                if(resp.success) {
                    if(resp.data) {
                        insertIserData( resp.data.name, resp.data.sure_name, resp.data.phone, resp.data.email );
                        fillStepTwoData();
                    }
                    getAddressAfterAuth();
                    afterAuth();

                    $checkoutLoginForm.closest('.checkout_wrap_row').find('.ch_l').addClass('no_edit');
                    $checkoutLoginForm.closest('.checkout_wrap_row').find('.btn-simple').hide();
                    let from = $(form).closest('.checkout_wrap_row').attr('id'),
                        to = $(form).closest('.checkout_wrap_row').attr('data-to');
                    secondSlide(from, to);
                } else {
                    bindErrors(form,resp);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 422) {
                    let errorObj = {};
                    if(jqXHR.responseJSON.errors) {
                        const objErrors = jqXHR.responseJSON.errors;
                        for (let property in objErrors) {
                            errorObj[property] = objErrors[property].join(',');
                        }
                    }
                    $checkoutLoginFormInit.showErrors(errorObj);
                }
            })
            .always(function () {
                $(form).find('button[type="submit"]').prop('disabled', false);
            });
        }
    });


    //Reset forms when user change tabs
    let $rFirst = $('#row_first');
    $rFirst.find('.tab_controls').on('click', 'a:not(.active)', function () {
        $checkoutRegisterForm[0].reset();
        $checkoutRegisterFormInit.resetForm();
        clearTimerCheckout()

        $checkoutLoginForm[0].reset();
        $checkoutLoginFormInit.resetForm();
    });

    function getAddressAfterAuth() {
        $.ajax({
            type: "GET",
            url: getAddressList,
            processData: false,
            contentType: false,
        })
        .then(function (resp) {
            addressAction.appAddressList.setAddress(resp);
            //Check address & show list if more 0
            if(resp.length) {
                $('#app-address-list').show();
                $('#delivery_3').hide();
            }
        });
    }

    function afterAuth() {
        $('.ajax-auth-on').removeAttr('style');
        $('.ajax-auth-off').hide();
    }


    /**
     * Step 2
     */
    let $fDelivery = $('#checkout_d-3, #checkout_d-4');
    $fDelivery.each(function () {
        let $fDeliveryInit = $(this).validate({
            highlight: function(element) {
                $(element).addClass("valid-error").removeClass("success");
            },
            unhighlight: function(element) {
                $(element).removeClass("valid-error").addClass("success");
            },
            submitHandler: function(form){
                var from = $(form).closest('.checkout_wrap_row').attr('id'),
                    to = $(form).closest('.checkout_wrap_row').attr('data-to');

                let action = $(form).attr('action'),
                    formData = new FormData($(form)[0]);

                // Check if the user doesn't want to register
                // and it was address section
                if(window.ONLY_BY && from === 'row_second') {
                    formData.append('only_render', window.ONLY_BY);
                    action = $(form).attr('data-render-url');
                }

                if(action) {
                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData
                    })
                        .then(function (resp) {
                            if(resp.success) {
                                let savedData = (resp.data[0]) ? resp.data[0].value_array : null,
                                    id = (resp.data[0]) ? resp.data[0].id : 0;
                                $(form).append('<input type="hidden" name="id" value="'+ id +'" />');

                                //Insert saved data
                                //console.log(savedData);

                                if(savedData) {
                                    $(form).find('input[name="del_first_name"]').val(savedData.first_name);
                                    $(form).find('input[name="del_last_name"]').val(savedData.last_name);
                                    $(form).find('input[name="del_phone"]').val(savedData.phone);
                                    $(form).find('input[name="delivery_type"]').val(savedData.delivery_type);
                                    $(form).find('input[name="address_delivery"]').val(savedData.full_address);
                                }

                                getAllInfo();
                                secondSlide(from, to);
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            if(jqXHR.status === 422) {
                                let errorObj = {};
                                if(jqXHR.responseJSON.errors) {
                                    const objErrors = jqXHR.responseJSON.errors;
                                    for (let property in objErrors) {
                                        errorObj[property] = objErrors[property].join(',');
                                    }
                                }
                                $fDeliveryInit.showErrors(errorObj);
                            }
                        })
                        .always(function () {
                            $(form).find('button[type="submit"]').prop('disabled', false);
                        });
                } else {
                    getAllInfo();
                    secondSlide(from, to);
                }

            }
        });
    });


    $('#row_second').find('.select_address').find('.to-delivery').on('click', function() {
        $(this).closest('.select_address').hide();
        $(this).closest('.select_address').siblings('.delivery_info').show();
        $('.pay_type-block').find('li:first-child').trigger('click');
    });


    /**
     * Step 3
     */
    let $fPay = $('#pay_form');
    let $fPayInit = $fPay.validate({
        highlight: function(element) {
            $(element).addClass("valid-error").removeClass("success");
        },
        unhighlight: function(element) {
            $(element).removeClass("valid-error").addClass("success");
        },
        submitHandler: function(form){
            let from = $(form).closest('.checkout_wrap_row').attr('id'),
                to = $(form).closest('.checkout_wrap_row').attr('data-to');

                secondSlide(from, to);
                $('#row_fourth .ch_l').addClass('ok');

                getAllInfo();
                buildData();
        }
    });

    $('.promocode-link').on('click', function () {
        $(this).siblings('.promocode-block').slideToggle(200);
    });

    let $promList = $('.promocode-list');

    $('body').on('click', '.promocode-delete', function() {
        let $this = $(this),
            action = $this.closest('form').attr('action'),
            code = $this.closest('li').attr('data-code').replace(/ /g,""),
            formData = {promo_code: code, is_delete: 'true'};

        ajaxPromo($this, action, formData);
    });

    $('body').on('click', '.promocode-add:not(:disabled)', function() {
        let $this = $(this),
            action = $this.closest('form').attr('action'),
            code = $this.siblings('#promocode_field').val().replace(/ /g,""),
            formData = {promo_code: code};

        ajaxPromo($this, action, formData);
    });

    function ajaxPromo($this, action, formData) {
        $this.prop('disabled', true);
        //NOTE TYPE: 1 - percent, 2 - uah

        $.ajax({
            type: "POST",
            url: action,
            data: formData,
            dataType: "json",
            success: function(res, textStatus, jqXHR) {
                if(res.success) {
                    $promList.html('');
                    for (const property in res.data) {
                        $promList.append(res.data[property].html);
                    }
                    $this.siblings('#promocode_field').val('');
                } else {
                    //$fPayInit.showErrors({promo_code: res.message});
                    $this.parent().find('label').remove();
                    $this.closest('.form-group').append('<label id="promocode_field-error" class="error" for="promocode_field">' + res.message + '</label>')
                }

                $(document).trigger('trigger.update.price.count');

                $this.prop('disabled', false);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 422) {
                    let errorObj = {};
                    if(jqXHR.responseJSON.errors) {
                        const objErrors = jqXHR.responseJSON.errors;
                        for (let property in objErrors) {
                            errorObj[property] = objErrors[property].join(',');
                        }
                    }
                    $fPayInit.showErrors(errorObj);
                }

                $this.prop('disabled', false);
            }
        });
    }

    $('body').on('keyup', '#promocode_field', function() {
        if($(this).val().length) {
            $(this).siblings('#promocode_field-error').hide();
        }
    });
    $('body').on('keyup', '#checkout_login input[name="sms_code"]', function() {
        $(this).closest('form').valid();
        if($(this).val().length >= 4 && $(this).closest('form').valid()){
            console.log($(this).closest('form').find('button[type="submit"]'))
            $(this).closest('form').find('button[type="submit"]').removeClass('prevented');
        } else {
            $(this).closest('form').find('button[type="submit"]').addClass('prevented');
        }
    });

    $('body').on('keyup', '#checkout_register input', function() {
        if($("#checkout_register").valid()){
            $(this).closest('form').find('button[type="submit"]').removeClass('prevented');
        } else {
            $(this).closest('form').find('button[type="submit"]').addClass('prevented');
        }
    });

    /**
     * Step 4
     */
    let $moreInfo = $('.more_info'),
        $rFourth = $('#row_fourth');

    $moreInfo.find('> a').on('click', function () {
        $(this).siblings('.form-group').slideToggle(200).find('textarea').focus();
    });


    $rFourth.find('.send-order').on('click', function () {
        let $this = $(this),
            formData = new FormData();
        $this.prop('disabled', true);
        // Check available & push to server
        new CartActions().checkAvailableProducts(function (res) {
            if(res.data.html) {
                $('#available-warn .modal-body').html(res.data.html);
                $(document).trigger('trigger.show.popup', ['available-warn']);
                $this.prop('disabled', false);
            } else {
                getAllInfo();

                formData.append('delivery_type', window.ALL_DATA.type_delivery);
                formData.append('delivery_name', window.ALL_DATA.name_delivery + ' ' + window.ALL_DATA.surname_delivery);
                formData.append('delivery_phone', window.ALL_DATA.tel_delivery);
                formData.append('delivery_address', window.ALL_DATA.address_delivery);
                formData.append('payment_type', window.ALL_DATA.type_pay);
                formData.append('message', window.ALL_DATA.more_info);
                formData.append('is_not_callback', window.ALL_DATA.call_checkbox);

                formData.append('order_name', window.ALL_DATA.user_name);
                formData.append('order_surname', window.ALL_DATA.user_sure_name);
                formData.append('order_phone', window.ALL_DATA.user_phone);
                formData.append('order_email', window.ALL_DATA.user_email);

                $.ajax({
                    type: "POST",
                    url: saveOrder,
                    processData: false,
                    contentType: false,
                    data: formData
                })
                .then(function (resp) {
                    if(resp.success) {
                        if (resp.data.payment_form) {
                            $(resp.data.payment_form).appendTo('body').submit();
                        } else {
                            window.location.href = resp.data.redirect;
                        }
                        return true;
                    }
                    alert('Order error');
                })
                .fail(function (xhr) {
                    //console.log(xhr);
                    alert('Order error.');
                })
                .always(function () {
                    $this.prop('disabled', false);
                });
            }
        });
    });

    /**
     * Edit rows
     */
    $('.checkout_tabs').on('click', '.checkout_wrap_row .ch_l:not(.disabled)', function (e) {
        e.preventDefault();
        let $this = $(this);

        if($this.siblings('.ch_content').css('display') !== 'none') return false;
        let $openBl = $('.checkout_wrap_row .ch_l.edit').siblings('.ch_content');

        if(validCloseBlock($openBl)) {
            $('.checkout_wrap_row .ch_content').slideUp(200);
            $this.siblings('.ch_content').slideDown(200, function () {
                $('.checkout_content .checkout_wrap_row').removeClass('edit_hide');
                $(this).parent().addClass('edit_hide');
                $this.addClass('edit');
                $openBl.siblings('.ch_l').removeClass('edit');
                getAllInfo();
                buildData();
            });
        }
    });


    $('body').on('keyup', '#login_card', function() {
        if($(this).val().length) {
            $('#login_phone_checkout').removeClass('valid-error').attr( "required", false );
            $('#login_phone_checkout-error').remove();
        } else {
            $('#login_phone_checkout').attr( "required", true );
        }
    });

    $('body').on('keyup', '#login_phone_checkout', function() {
        if($(this).hasClass('completed')) {
            $('#login_card').removeClass('valid-error').attr( "required", false);
            $('#login_card-error').remove();
        } else {
            $('#login_card').removeClass('ignore').attr( "required", true);
        }
    });

}

let intrvlCheckout = 0;
function timerCheckoutMain(data) {
    $(data).find('.sms-checkout__again').hide(0);
    $(data).find('.sms-checkout__info').show(0);
    $(data).find('.sms-checkout__desc').show(0);
    $(data).find('.checkout-code').show(0);
    $(data).find('.checkout-code input').focus().val('');
    $(data).find('.checkout-code label.error').remove();

    let spanTime = $(data).find('.sms-checkout__desc span[data-time]');
    let time = Number(spanTime.data('time'));
    time = time - 1;
    intrvlCheckout = setInterval(function() {
        if (time <= 0) {
            clearInterval(intrvlCheckout);
            $(data).find('.sms-checkout__desc').hide();
            $(data).find('.sms-checkout__again').show();
            spanTime.text(time);
            time = Number(spanTime.data('time'));
        }
        spanTime.text(time--)
    }, 1000)
}

function clearTimerCheckout() {
    clearInterval(intrvlCheckout);
    $('.sms-block__desc span').text(60);
    $('.sms-checkout__desc').hide(0);
    $('.sms-checkout__again').show(0);
}

//General
function paymentRules() {
    let $paySelect = $('.pay_type-block');
    if($paySelect.length) {
        let totalCart = parseFloat($('.cart-total__sum').attr('data-price'));
        let minCart = parseFloat(window.cart_min_cap);

        if(totalCart && minCart) {
            let $allPays = $paySelect.find('li');
            $allPays.each(function () {
                let max = !!+$(this).attr('data-max');
                let min = !!+$(this).attr('data-min');
                if(max && !min) {
                    if(minCart > totalCart) {
                        $(this).addClass('empty').hide();
                    } else {
                        $(this).removeClass('empty').show();
                    }
                } else if(!max && min) {
                    if(totalCart >= minCart) {
                        $(this).addClass('empty').hide();
                    } else {
                        $(this).removeClass('empty').show();
                    }
                } else if(!max && !min) {
                    $(this).addClass('empty').hide();
                } else {
                    $(this).removeClass('empty').show();
                }
            });
        }

        //NOTE: ховаємо наложку якщо юзер вибрав самовивіз або кур'єра.
        if(!$paySelect.find('[id="3"]').hasClass('empty')) {
            if(window.ALL_DATA.type_delivery === '1' || window.ALL_DATA.type_delivery === '4') {
                $paySelect.find('[id="3"]').addClass('empty').hide();
            } else {
                $paySelect.find('[id="3"]').removeClass('empty').show();
            }
        }

        $paySelect.find('[id]:not(.empty)').first().trigger('click');
    }
}

$(document).bind('trigger.cart.calculated', function () {
    paymentRules();
});

/**
 * Insert data for user in step4
 */
function buildData() {
    let $fourRow = $('#row_fourth');

    //User data
    $fourRow.find('li.user_name .value').html(window.ALL_DATA.user_name);
    $fourRow.find('li.user_sure_name .value').html(window.ALL_DATA.user_sure_name);
    $fourRow.find('li.user_phone .value').html(window.ALL_DATA.user_phone);
    $fourRow.find('li.user_email .value').html(window.ALL_DATA.user_email);
    if(window.ALL_DATA.user_email) {
        $fourRow.find('li.user_email').removeAttr('style');
    } else {
        $fourRow.find('li.user_email').hide();
    }

    //Delivery
    $fourRow.find('li.name_delivery .value').html(window.ALL_DATA.name_delivery);
    $fourRow.find('li.surname_delivery .value').html(window.ALL_DATA.surname_delivery);
    $fourRow.find('li.tel_delivery .value').html(window.ALL_DATA.tel_delivery);
    $fourRow.find('li.address_delivery .value').html(window.ALL_DATA.address_delivery);
    $fourRow.find('li.type_delivery .value').css('display', 'none');
    $fourRow.find('li.type_delivery .value_' + (window.ALL_DATA.type_delivery)).removeAttr('style');

    //Type Pay
    $fourRow.find('li.type_pay .value').css('display', 'none');
    $fourRow.find('li.type_pay .value_' + (window.ALL_DATA.type_pay)).removeAttr('style');
    if($('.promocode-list li').length) {
        $fourRow.find('li.promocode-row').css('display', 'flex');
        $fourRow.find('li.promocode-row .value').find('span').remove();
        $('.promocode-list li').each(function() {
            $fourRow.find('li.promocode-row .value').append('<span>' + $(this).find('span').html() + '<span>' + $(this).find('p').html() + '</span></span>');
        });
    } else {
        $fourRow.find('li.promocode-row').css('display', 'none');
    }
}

/**
 * insert all data to global variable
 * @ window.ALL_DATA
 */
function getAllInfo() {
    //User data
    let $fRow = $('#row_first');
    window.ALL_DATA.user_name = $fRow.find('input[name="user_name"]').val();
    window.ALL_DATA.user_sure_name = $fRow.find('input[name="user_sure_name"]').val();
    window.ALL_DATA.user_phone = $fRow.find('input[name="user_phone"]').val();
    window.ALL_DATA.user_email = $fRow.find('input[name="user_email"]').val();

    //Delivery
    let $deliveryArea = $('#row_second');
    let $activeCont = $deliveryArea.find('input[type="radio"]:checked + label');

    if(!$activeCont.length) {
        $activeCont = $deliveryArea.find('#checkout_d-3');
    }

    window.ALL_DATA.name_delivery = $activeCont.find('input[name="del_first_name"]').val();
    window.ALL_DATA.surname_delivery = $activeCont.find('input[name="del_last_name"]').val();
    window.ALL_DATA.tel_delivery = $activeCont.find('input[name="del_phone"]').val();
    window.ALL_DATA.type_delivery = $activeCont.find('input[name="delivery_type"]').val();
    window.ALL_DATA.address_delivery = $activeCont.find('input[name="address_delivery"]').val();


    //Type pay
    let $payArea = $('#row_third');
    window.ALL_DATA.type_pay = $payArea.find('input[name="pay_type"]').val();
    paymentRules();

    //Get comment
    window.ALL_DATA.more_info = $('#row_fourth textarea[name="more_info"]').val();
    window.ALL_DATA.call_checkbox = $('#row_fourth input[name="call_checkbox"]').prop('checked');
}

// Insert user data to hidden input for next use
function insertIserData(name, sure_name, phone, email) {
    var $rFirst = $('#row_first');
    $rFirst.find('input[name="user_name"]').val(name);
    $rFirst.find('input[name="user_sure_name"]').val(sure_name);
    $rFirst.find('input[name="user_phone"]').val(phone);
    $rFirst.find('input[name="user_email"]').val(email);
}


// After refistration bind to delivery
function fillStepTwoData() {

    let $rFirst = $('#row_first');
    let user_name = $rFirst.find('input[name="user_name"]').val();
    let user_sure_name = $rFirst.find('input[name="user_sure_name"]').val();
    let user_phone = $rFirst.find('input[name="user_phone"]').val();
    let user_email = $rFirst.find('input[name="user_email"]').val();

    $('#del_name').val(user_name);
    $('#del_surname').val(user_sure_name);
    $('#del_phone').val(user_phone);

}

// General
/**
 * Change row
 * @param from
 * @param to
 */
function secondSlide(from, to) {
    let $from = $('#'+from),
        $to = $('#'+to);

    //TODO: потрібен для блокування блоку від редагування
    //$('.checkout_content .checkout_wrap_row').removeClass('edit_hide');

    $from.find('.ch_l').addClass('ok').removeClass('edit');
    $from.find('.ch_content').slideUp(200);

    $to.find('.ch_l').removeClass('disabled').addClass('edit').parent().addClass('edit_hide');
    $to.find('.ch_content').slideDown(200);

    if($(window).width() < 768) {
        setTimeout(function() {
            $("html, body").animate({ scrollTop: $to.offset().top - 60 }, 400);
        }, 200);
    }
}

/**
 *
 * @param $element
 */
function validCloseBlock($element) {
    let result = true;
    if($element.find('.tab_content').length) {
        $element.find('.tab_content').each(function () {
            if($(this).css('display') !== 'none') {
                let $visibleForm = $(this).find('form');
                if ($visibleForm.valid()) {
                    result = true;
                    return false;
                } else {
                    result = false;
                    return false;
                }
            }
        });
    } else {
        if($element.find('form').length) {
            let $visibleForm = $element.find('form');
            if ($visibleForm.valid()) {
                result = true;
                return result;
            } else {
                result = false;
                return false;
            }
        } else {
            result = true;
        }
    }

    return result;
}


function bindErrors(form, resp) {

    if (typeof resp.errors != 'undefined') { // array error bind

        $.each(resp.errors, function (name, value) {

            let field = $(form).find('[name=' + name + ']');
            field.addClass('error');

            if (field.siblings('.error').length) {
                field.siblings('.error').text(value);
                field.siblings('.error').show();
            } else {
                field.after('<label id="' + name + '-error" class="error" for="' + name + '">' + value + '</label>');
            }
        });

    }

    if (typeof resp.message != 'undefined'){ // general error message
        //console.log(resp.message);
    }

    return true;

}
